<template>
  <div class="c-block-management-toolbar flex flex-wrap justify-between items-start gap-4 pa-4 rounded-2 mb-3 bg-base">
    <div class="flex flex-wrap items-center gap-2 flex-1">
      <CSearchFilters
        :customFilterComponents="customFilterComponents"
        :disabled="!!isLoadingItems"
        entity="canvas"
        :filters="metadataFilterValues"
        hide-metadata-filters
        :initial-search-value="search"
        is-block
        :placeholder="t('canvasUI.components.blocks.CBlockManagementToolbar.searchInNameOrTags')"
        @update:filters="emit('update:filter-values', $event)"
        @update:search="emit('search', $event)"
      />
    </div>
    <div class="flex gap-4">
      <CTableColumnsSettings
        v-if="!hideView"
        :table-columns-settings="tableColumnsSettings"
        :tooltip-text="t('canvasUI.components.blocks.CBlockManagementToolbar.configureColumns')"
        @move="(payload) => emit('move', payload)"
        @restore="$emit('restoreColumns')"
        @select="(payload) => emit('select', payload)"
      />
      <CButton v-if="!hideCreate" type="primary" @click="$emit('create:block')">
        {{ t('canvasUI.components.blocks.CBlockManagementToolbar.createBlock') }}
        <template #icon>
          <CIcon icon="plus" size="16px" />
        </template>
      </CButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import CSearchFilters from '@lib/components/CSearchFilters/CSearchFilters.vue'
import CTableColumnsSettings, {
  type TableColumnSetting,
} from '@lib/components/CTableColumnsSettings/CTableColumnsSettings.vue'
import type { MetadataTemplateFieldTypeEnum } from '@openapi'

defineProps<{
  hideCreate?: boolean
  hideView?: boolean
  isLoadingItems?: boolean
  search: string
  metadataFilterValues: Record<string, any>
  tableColumnsSettings: TableColumnSetting[]
  customFilterComponents?: {
    type: MetadataTemplateFieldTypeEnum
    name: string
    label: string
    options?: { label: string; value: string }[]
  }[]
}>()

const emit = defineEmits<{
  (e: 'search', value: string): void
  (e: 'create:block'): void
  (e: 'update:filter-values', value: Record<string, any>): void
  (e: 'move', payload: { targetItemId: TableColumnSetting['id']; itemId: string }): void
  (e: 'select', payload: { id: TableColumnSetting['id']; checked: boolean }): void
  (e: 'restoreColumns'): void
}>()

const { t } = useI18n()
</script>
